import React, { Component, Fragment } from "react";
import FilterHeader from "./components/FilterHeader";
import Grid from "./components/Grid";
import { API_LINK } from "./util/constants";
import LoadMore from "./components/LoadMore";
import Map from "./components/Map";
import PlannerFilter from "./components/Filter/PlannerFilter";
import {
    clearScrollPosition,
    filterGTMDataPush,
    getFormData,
    getInitialData,
    getScrollPosition,
    setFormData,
    setScrollPosition,
} from "./util/sessions";

class App extends Component {
    state = {
        panels: [],
        offset: 0,
        isLast: false,
        initialLoading: false,
        isPopupOpened: false,
        selectedPanelID: null,
        isFilterOpen: false,

        variables: getFormData(this.props.settings.type),
    };

    componentDidMount() {
        this.fetchData(false);
        document.addEventListener("click", (e) => {
            if (e.target.closest(".panel__link")) {
                setScrollPosition(this.props.settings.type, window.pageYOffset);
            } else {
                clearScrollPosition(this.props.settings.type);
            }
        });
    }

    render() {
        const { variables, isFilterOpen } = this.state;
        const { splitView } = variables;

        const toggleFilterOpen = () => {
            this.setState({ isFilterOpen: !isFilterOpen });
        };

        return (
            <Fragment>
                {!this.props.settings.isLiveStream && this.renderFilters()}

                <div
                    className={`planner-layout-wrapper ${
                        splitView ? "planner-layout-wrapper--split" : ""
                    } ${
                        isFilterOpen
                            ? "planner-layout-wrapper--filter-open"
                            : "planner-layout-wrapper--filter-closed"
                    }`}
                >
                    <div
                        className="planner-filter-open-button"
                        onClick={toggleFilterOpen}
                    >
                        <div className="planner-filter-open-button__content">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 17.5 16.292"
                            >
                                <path
                                    id="Path_15"
                                    fill-rule="evenodd"
                                    fill="#fff"
                                    stroke="#fff"
                                    stroke-width=".5"
                                    d="M17.25 2.682h-3.1A3.036 3.036 0 0 0 11.175.25 3.036 3.036 0 0 0 8.2 2.682H.25v1.214h7.954a3.036 3.036 0 0 0 2.975 2.432 3.036 3.036 0 0 0 2.975-2.432h3.096Zm-6.071 2.429A1.822 1.822 0 0 1 9.358 3.29a1.822 1.822 0 0 1 1.821-1.821A1.822 1.822 0 0 1 13 3.29a1.822 1.822 0 0 1-1.821 1.821ZM.25 13.611h3.1a3.036 3.036 0 0 0 2.975 2.432A3.036 3.036 0 0 0 9.3 13.611h7.95v-1.214H9.296a3.036 3.036 0 0 0-2.975-2.432 3.036 3.036 0 0 0-2.975 2.432H.25Zm4.25-.607a1.821 1.821 0 0 1 1.821-1.821 1.821 1.821 0 0 1 1.821 1.821 1.821 1.821 0 0 1-1.821 1.821A1.821 1.821 0 0 1 4.5 13.003Z"
                                    data-name="Path 15"
                                />
                            </svg>
                            <h4>{"Filters"}</h4>
                        </div>
                    </div>

                    <Fragment>
                        <div className="planner-layout">
                            <PlannerFilter
                                setQueryVar={this.setQueryVar.bind(this)}
                                unCheckRegion={this.unCheckRegion.bind(this)}
                                setRegionQueryVar={this.setRegionQueryVar.bind(
                                    this
                                )}
                                onClearFilter={this.onClearFilter.bind(this)}
                                variables={this.state.variables}
                                {...this.props.settings}
                                toggleFilterOpen={toggleFilterOpen}
                            />

                            {this.renderContent()}
                        </div>
                    </Fragment>
                </div>
            </Fragment>
        );
    }

    renderFilters() {
        const { variables, isPopupOpened } = this.state;
        const { splitView } = variables;

        return (
            <div className="planner-header-wrapper">
                <FilterHeader
                    setQueryVar={this.setQueryVar.bind(this)}
                    variables={variables}
                    splitView={splitView}
                    toggleSplitView={() => {
                        const newView = !splitView;
                        const newVars = {
                            ...variables,
                            splitView: newView,
                        };
                        setFormData(this.props.settings.type, newVars);
                        this.setState({ variables: newVars });
                    }}
                    isPopupOpened={isPopupOpened}
                    togglePopup={() =>
                        this.setState({ isPopupOpened: !isPopupOpened })
                    }
                    {...this.props}
                />
            </div>
        );
    }

    renderContent() {
        const {
            panels,
            initialLoading,
            variables,
            isLast,
            loading,
            selectedPanelID,
        } = this.state;
        const { splitView } = variables;

        if (initialLoading) {
            return (
                <div className="planner-layout">
                    <p>Loading...</p>
                </div>
            );
        }

        if (!panels.length) {
            return (
                <div className="planner-layout">
                    <p>No results found!</p>
                </div>
            );
        }

        const markers = panels.map((panel) => {
            const lat = parseFloat(panel.latitude);
            const lng = parseFloat(panel.longitude);

            return {
                id: panel.id,
                label: panel.name,
                position: { lat, lng },
                panelInfo: { ...panel },
            };
        });

        return (
            <div className="planner-layout__right">
                {splitView && (
                    <div className="panels-map">
                        <Map
                            markers={markers}
                            onMarkerClick={(id) =>
                                this.setState({ selectedPanelID: id })
                            }
                        />
                    </div>
                )}
                <Grid
                    panels={panels}
                    selectedPanelID={selectedPanelID}
                    isSplitView={splitView}
                    isLiveStream={this.props.settings.isLiveStream}
                />

                {splitView && (
                    <LoadMore
                        handleLoadMore={this.handleLoadMore.bind(this)}
                        loading={loading}
                        isLast={isLast}
                    />
                )}
                {!splitView && (
                    <LoadMore
                        handleLoadMore={this.handleLoadMore.bind(this)}
                        loading={loading}
                        isLast={isLast}
                    />
                )}
            </div>
        );
    }

    handleLoadMore() {
        let { offset } = this.state;
        const variables = {
            ...this.state.variables,
            ...{ offset: offset + 1 },
            ...{ loadMoreClicked: true },
        };
        setFormData(this.props.settings.type, variables);
        this.setState({ variables }, () => this.fetchData(true));
    }

    setQueryVar(field, value, isMulti, category = null) {
        const current = this.state.variables;
        if (isMulti && !Array.isArray(value)) {
            const fieldValues = current[field];
            const found = fieldValues.find((v) => v === value);
            if (found) {
                value = fieldValues.filter((v) => v !== value);
            } else {
                fieldValues.push(value);
                value = fieldValues;
            }
        }
        const variables = {
            ...this.state.variables,
            ...{ [field]: value },
            ...{ offset: 0 },
        };

        filterGTMDataPush(
            field === "cityIDs" ? "regionSelect" : field,
            variables,
            this,
            value,
            category,
            isMulti
        );

        setFormData(this.props.settings.type, variables);

        this.setState({ variables }, () => this.fetchData(false));
    }

    setRegionQueryVar(regionIDs, cityIDs) {
        const variables = {
            ...this.state.variables,
            ...{
                regionIDs: regionIDs,
                cityIDs: cityIDs,
                offset: 0,
                loadMoreClicked: false,
            },
        };
        filterGTMDataPush("regionSelect", variables, this);
        setFormData(this.props.settings.type, variables);

        this.setState({ variables }, () => this.fetchData(false));
    }

    unCheckRegion(region) {
        const { regionIDs, cityIDs } = this.state.variables;
        const regionCityIDs = region.cities.map((r) => r.id);
        const variables = {
            ...this.state.variables,
            ...{
                regionIDs: regionIDs.filter((r) => r !== region.id),
                cityIDs: cityIDs.filter((c) => !regionCityIDs.includes(c)),
                offset: 0,
            },
        };
        setFormData(this.props.settings.type, variables);

        this.setState({ variables }, () => this.fetchData(false));
    }

    onClearFilter() {
        const variables = this.getInitialVariables();
        setFormData(this.props.settings.type, variables);

        this.setState({ variables }, () => this.fetchData(false));
    }

    getInitialVariables() {
        return getInitialData();
    }

    fetchData(isLoadMore) {
        const xhr = require("xhr");
        const { variables, panels } = this.state;

        if (!isLoadMore) {
            this.setState({ initialLoading: true });
        } else {
            this.setState({ loading: true });
        }

        xhr.post(
            API_LINK,
            { body: JSON.stringify(variables) },
            (error, resp) => {
                const data = JSON.parse(resp.body);

                if (isLoadMore) {
                    data.panels = [...panels, ...data.panels];
                }

                data.loading = false;
                data.initialLoading = false;
                this.setState(data, () => {
                    const position = getScrollPosition(
                        this.props.settings.type
                    );
                    if (position) {
                        window.scrollTo({
                            top: position,
                            behavior: "auto",
                        });
                        clearScrollPosition(this.props.settings.type);
                    }
                });
            }
        );
    }
}

export default App;
